import ERROR_CODE from '../config/errors';

/**
 * CodedErrors are errors that have been interpreted and given meaning.
 *
 * @class CodedError
 * @extends {Error}
 */
class CodedError extends Error {

  /**
   * @constructor
   * @param   {Error}   originalError   The original error that was thrown.
   * @param   {Object}  errorCode       An error code from the ERROR_CODE enum.
   * @param   {*}       [data]          Optional. Any additional data.
   */
  constructor(originalError = new Error(), {code, message, link, linkText} = ERROR_CODE.UNKNOWN, data) {
    super();
    this.originalError = originalError;
    this.code = code;
    this.message = message;
    this.link = (typeof link === 'function') ? link(data) : link;
    this.linkText = linkText;
    this.data = data;
    this.stack = originalError.stack;
    this.name = this.constructor.name;
    console.log(this);
  }

  static getMessage(error = new CodedError(undefined, ERROR_CODE.UNKNOWN)) {
    return error.message;
  }

  static isCoded(error = new Error()) {
    return error.code != null;
  }
}

export default CodedError;
export { ERROR_CODE };



// WEBPACK FOOTER //
// ./client/app/util/CodedError.js